<template>
  <div class="energy-trends">
    <div class="energy-trends-condition">
      <div class="item">
        <span class="title">制冷机组</span>
        <el-select v-model="buildingId" :clearable="dateClear" placeholder="请选择" style="width: 70%;" @change="queryMonthTrends">
          <el-option v-for="item in buildingOpts" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>
      <div class="item">
        <span class="title">年份</span>
        <el-date-picker v-model="selectDate" type="year" value-format="yyyy" placeholder="选择年份" :clearable="dateClear"
          style="width: 60%;" @change="queryMonthTrends" />
      </div>
    </div>
    <div class="energy-trends-charts">
      <div id="yearTrendsChart" style="width: 100%; height: 12rem"></div>
    </div>
  </div>
</template>

<script>
import { api } from '../api/api'
import dayjs from "dayjs"
import eCharts from "echarts"
export default {
  data() {
    return {
      buildingId: 8,
      buildingOpts: [{ 'label': '1号冷库制冷机组', 'value': 8 }, { 'label': '5号冷库制冷机组', 'value': 9 }],
      selectDate: dayjs(new Date()).format('YYYY'),
      dateClear: false,
      yearTrendsChart: null,
      monthTrendsChartOpt: {},
      xData: [],
      yDataA: [],
      yDataB: []
    }
  },
  mounted() {
    this.queryMonthTrends()
    window.onresize = () => {
      this.yearTrendsChart.resize()
    };
  },
  methods: {
    async queryMonthTrends() {
      this.xData = []
      this.yDataA = []
      this.yDataB = []
      const {
        success,
        returnObj
      } = await this.$fetch(api.yearBuildenergyConsumption + '?buildId=' + this.buildingId + '&date=' + this.selectDate)
      if (success && returnObj.length > 0) {
        for (let i = 0; i < returnObj.length; i++) {
          this.xData.push(returnObj[i].keyX)
          this.yDataA.push(returnObj[i].dataY)
          this.yDataB.push(returnObj[i].beforeDataY)
        }
        this.initBuildingPowerChart()
      }
    },
    initBuildingPowerChart() {
      let chartDom = document.getElementById("yearTrendsChart");
      this.yearTrendsChart = eCharts.init(chartDom);
      this.monthTrendsChartOpt = {
        // color: ['#00BFFF', '#12CE6C'],
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          // data: ['当年', '上年'],
          icon: "rect",
          itemHeight: 12,
          itemWidth: 25,
          right: 40,
          top: 10
        },
        grid: {
          left: '1%',
          right: '5%',
          bottom: '0',
          top: '20%',
          containLabel: true
        },
        xAxis: {
          name: '月',
          type: 'category',
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: 'rgba(104,105,123)'
            }
          },
          // axisLabel: {
          //   interval: 0,//横轴信息全部显示
          //   rotate: -50,// -20度角倾斜显示
          // },
          splitLine: {
            lineStyle: {
              color: "rgba(104,105,123)",
              type: "dashed"
            }
          },
          data: this.xData
        },
        yAxis: {
          type: 'value',
          name: "单位：kwh",
        },
        series: [
          {
            name: '当前年',
            type: 'line',
            smooth: true,
            // stack: 'Total',
            data: this.yDataA,
            color: '#00BFFF'
          },
          {
            name: '上一年',
            type: 'line',
            smooth: true,
            // stack: 'Total',
            data: this.yDataB,
            color: '#12CE6C'
          }
        ]
      }
      this.yearTrendsChart.setOption(this.monthTrendsChartOpt);
    },
  }
}
</script>

<style lang="scss" scoped>
.energy-trends {
  width: 100%;
  height: 100%;
}

.energy-trends-condition {
  width: 100%;
  display: flex;
  flex-direction: row-reverse;
  margin-top: 20px;

  .item {
    margin-right: 10px;

    .title {
      margin-right: 10px;
    }
  }
}
</style>